import { Link } from 'react-router-dom';
import '../../styles/common/header.css';
import logo from '../../assets/icons/logo.svg'



function Header() {



    return (
        <nav>
            <a href="/">
                <img src={logo} alt='logo-nettri'></img>
            </a>
            <ul>
                <li>
                    <Link to="/">Home</Link>
                </li>

                <li>
                    <Link to="/contratos">Contratos</Link>
                </li>

                <li>
                    <Link to="/contato">Contato</Link>
                </li>

            </ul>
        </nav>
    );
}

export default Header;